<template>
    <transition name="fade" tag="v-layout" class="row wrap">
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <transition name="fade" mode="out-in">
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Overview
                    <v-spacer></v-spacer>
                    <div style="width:120px">
                        <v-menu
                                v-model="menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="date"
                                        prepend-icon="fa-calendar"
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="date" @input="menu = false" @change="handleDateChange()"></v-date-picker>
                        </v-menu>
                    </div>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-layout row wrap>
                            <v-flex xs12 md6>
                                <vue-plotly disable-responsive v-if="energyData" :data="energyData" :layout="energyLayout" :options="{}"/>
                            </v-flex>
                            <v-flex xs12 md6>
                                <v-layout row wrap>
                                    <v-flex xs12 md4>
                                        <vue-plotly v-if="ahuOnData" disable-responsive :data="ahuOnData" :layout="ahuOnLayout" :options="{}"/>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <vue-plotly v-if="chillerOnData" disable-responsive :data="chillerOnData" :layout="chilerOnLayout" :options="{}"/>
                                    </v-flex>

                                    <v-flex xs12 md4>
                                        <vue-plotly v-if="roomTempData" disable-responsive :data="roomTempData" :layout="roomTempLayout" :options="{}"/>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12>
                        <v-layout row wrap>
                            <v-flex xs12 md6>
                                <v-data-table
                                        :headers="headers"
                                        disable-initial-sort
                                        :items="faults"
                                        :rows-per-page-items="[7,14,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                >
                                    <template v-slot:items="props">
                                        <td class="text-xs-left">{{ props.item.title }}</td>
                                        <td class="text-xs-left">{{ props.item.equipment_name }}</td>
                                        <td class="text-xs-left">{{ props.item.equipment_type }}</td>
                                        <td class="text-xs-left">{{ props.item.floor }}</td>
                                        <td class="text-xs-left">{{props.item.start_date}}</td>
                                        <td class="text-xs-left">{{props.item.end_date}}</td>
                                        <td class="justify-center layout px-0">
                                            <v-icon
                                                    small
                                                    @click="jumpToLink(props.item)"
                                            >
                                                fa-chart-line
                                            </v-icon>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-flex>
                            <v-flex xs12 md6>
                                <v-layout row wrap>
                                    <v-flex xs12 md6>
                                        <vue-plotly v-if="faultPieData1" disable-responsive :data="faultPieData1"
                                                    :layout="faultPieLayout1" :options="{}" @click="jumpToNotification($event,'severity')"/>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <vue-plotly v-if="faultPieData2" disable-responsive :data="faultPieData2"
                                                    :layout="faultPieLayout2" :options="{}" @click="jumpToNotification($event,'topic')"/>
                                    </v-flex>
                                </v-layout>

                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
        </transition>
    </transition>
</template>

<script>

    import moment from 'moment'
    import {callAPI,getNotification} from '@/helper'
    import VuePlotly from "../../components/VuePlotly";


    export default {
        name: 'EsDashboard',
        components: {VuePlotly},
        data () {
            return {
                menu:false,
                baseDate:  moment().subtract(1, "days"),
                date:  moment().subtract(1, "days").format("YYYY-MM-DD"),
                loading:true,
                energyData:null,
                severityColors:{
                    critical:'rgb(148, 103, 189)',
                    low:'rgb(188, 189, 34)',
                    medium:'rgb(255, 127, 14)',
                    high:'rgb(214, 39, 40)',
                },
                chillers:[],
                pumps:[],
                ahus:[],
                paus:[],
                headers: [
                    {
                        text: 'Issue',
                        align: 'left',
                        sortable: true,
                        value: 'title'
                    },
                    {text: 'Equipment', value: 'equipment_name'},
                    {text: 'Equipment Type', value: 'equipment_type'},
                    {text: 'Floor', value: 'floor'},
                    {text: 'Start Date', value: 'start_date'},
                    {text: 'End Date', value: 'end_date'},
                    {text: 'Actions', value: 'name', sortable: false}
                ],
                faults:[],
                energyLayout:{
                    title:"Energy Consumption VS Baseline",
                    legend: {
                        orientation: 'h',
                        x: 0,
                        y: 1.1
                    },
                    yaxis: {
                        title: 'Energy (kWh)'
                    },
                    xaxis: {
                        title: 'Hour'
                    }
                },
                faultPieData1:null,
                faultPieData2:null,
                faultPieLayout1:{
                    title:"Fault severity",
                    legend: {
                        orientation: 'h',
                        x: 0.1
                    },
                    margin:{
                        l: 20,
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },
                faultPieLayout2:{
                    title:"Fault breakdown",
                    legend: {
                        orientation: 'h',
                        x:0.1
                    },
                    margin:{
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },
                roomTempData:null,
                roomTempLayout:{
                    title:"Room Temperature (°C)",
                    showlegend:false,
                    hovermode: 'closest',
                    xaxis: {
                        showgrid:false,
                        ticks:'',
                        showticklabels:false
                    },
                    yaxis: {
                        range:[0,35]
                    },
                    margin:{
                        l: 20,
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },
                ahuOnData:null,
                ahuOnLayout:{
                    title:"AHU Run Time (hr)",
                    showlegend:false,
                    hovermode: 'closest',
                    xaxis: {
                        showgrid:false,
                        ticks:'',
                        showticklabels:false
                    },
                    margin:{
                        l: 20,
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },
                chillerOnData:null,
                chilerOnLayout:{
                    title:"Chiller Run Time (hr)",
                    hovermode: 'closest',
                    showlegend:false,
                    xaxis: {
                        showgrid:false,
                        ticks:'',
                        showticklabels:false
                    },
                    margin:{
                        l: 20,
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },


            }
        },

        methods:{
            jumpToNotification(data,facet) {
              let output = {
                        path: '/notification-breakdown',
                  query:{
                      rangeStart: this.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                      rangeEnd: this.baseDate.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                  }
                    }
                output.query[facet]=data.points[0].label
              this.$router.push(output)
            },
            jumpToLink(item) {
                let output = null;
                if (item.title.substring(0,7) === "Anomaly") {
                    output = {
                        path: '/modelsummary',
                        query: {
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipment: item.equipment_name
                        }
                    }
                } else {
                    output = {
                        path: '/fault-analysis',
                        query: {
                            relevantVariables: item.to.query.variableX,
                            faultName: item.title,
                            faultDesc: item.description,
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipmentName: item.equipment_name
                        }
                    }
                }

                this.$router.push(output)
                // this.$store.dispatch('updateMaintenanceItem', this.getMaintenanceItem(item))
                // this.$router.push(item.to)
            },
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    if(!ar2[i]){
                        ar3.push(ar1[i]);
                    } else {
                        ar3.push(ar1[i] + ar2[i]);
                    }
                return ar3;
            },
            handleDateChange(){
                this.baseDate = moment(this.date)
                this.getData()
            },
            getData(){
                let me=this;
                me.loading=true
                me.chillers=[]
                me.pumps=[]
                me.ahus=[]
                me.paus=[]
                let currentRange=[me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.baseDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                let pastdate=moment(me.baseDate).subtract(7, "days")
                let pastRange=[pastdate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),pastdate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(equip.equipment_type.toLowerCase().startsWith('chiller')){
                        me.chillers.push(equip.equipment_name)
                    } else if(equip.equipment_type==="ECFAN"||equip.equipment_type==="AHU"){
                        me.ahus.push(equip.equipment_name)
                    }else if(equip.equipment_type==="PAU"){
                        me.paus.push(equip.equipment_name)
                    }
                }
                me.ahus.sort()
                callAPI('data2/',
                    {
                        'filters': {
                            'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_type_regex': '^chiller',
                            'sensor_names': ["on"],
                            'date_range':currentRange,
                        },
                        "pipeline": [
                            {"type": "agg", "agg": "D", "agg_op": "sum"}
                        ]
                    }
                ).then(function(chillerOnRes){
                    if(chillerOnRes) {
                        let chillerNames = []
                        let chillerOn = []
                        for (let index in chillerOnRes.data) {
                            if (index == "timestamp") {
                                continue
                            }
                            let chillerName = index.split(' - ')[0];
                            chillerNames.push(chillerName)
                            chillerOn.push(chillerOnRes.data[index][0] / me.$store.state.pointsListStore.pointsList.sampling_freq)
                        }
                        me.chillerOnData = [{
                            x: chillerNames,
                            y: chillerOn,
                            type: 'scatter',
                            mode: 'markers',
                            marker: {
                                symbol: 'circle',
                                size: 10
                            }
                        }]
                    }
                })
                if(me.ahus.length>0) {
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_type_regex': 'ecfan|ahu',
                                'sensor_names': ['INVERT', 'RT_TEM'],
                                'date_range': currentRange,
                            }
                        }
                    ).then(function (ahuRes) {
                        let increm = 1 / me.$store.state.pointsListStore.pointsList.sampling_freq
                        let ahuNames = []
                        let ahuOn = []
                        let ahuTemps = []
                        for (let ahuName of me.ahus) {
                            if (ahuRes.data[ahuName + ' - INVERT']) {
                                let ahuTempArray = []
                                ahuNames.push(ahuName)
                                let ontime = 0
                                for (let flowindex in ahuRes.data[ahuName + ' - INVERT']) {
                                    let flow = ahuRes.data[ahuName + ' - INVERT'][flowindex]
                                    if (flow >= 20) {
                                        ontime = ontime + increm
                                        if (ahuRes.data[ahuName + ' - RT_TEM']) {
                                            ahuTempArray.push(ahuRes.data[ahuName + ' - RT_TEM'][flowindex])
                                        }
                                    }
                                }
                                ahuOn.push(ontime)
                                ahuTemps.push(ahuTempArray.reduce((p, c) => p + c, 0) / ahuTempArray.length)
                            }
                        }
                        me.ahuOnData = [{
                            x: ahuNames,
                            y: ahuOn,
                            type: 'scatter',
                            mode: 'markers',
                            marker: {
                                symbol: 'circle',
                                size: 10
                            }
                        }]
                        me.roomTempData = [{
                            x: ahuNames,
                            y: ahuTemps,
                            type: 'scatter',
                            mode: 'markers',
                            marker: {
                                symbol: 'circle',
                                size: 10
                            }
                        }]
                    })
                } else if (me.paus.length>0){
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_type': 'PAU',
                                'sensor_names': ['INVERT', 'CD_TEM'],
                                'date_range': currentRange,
                            }
                        }
                    ).then(function (ahuRes) {
                        let increm = 1 / me.$store.state.pointsListStore.pointsList.sampling_freq
                        let ahuNames = []
                        let ahuOn = []
                        let ahuTemps = []
                        for (let ahuName of me.paus) {
                            if (ahuRes.data[ahuName + ' - INVERT']) {
                                let ahuTempArray = []
                                ahuNames.push(ahuName)
                                let ontime = 0
                                for (let flowindex in ahuRes.data[ahuName + ' - INVERT']) {
                                    let flow = ahuRes.data[ahuName + ' - INVERT'][flowindex]
                                    if (flow >= 20) {
                                        ontime = ontime + increm
                                        if (ahuRes.data[ahuName + ' - CD_TEM']) {
                                            ahuTempArray.push(ahuRes.data[ahuName + ' - CD_TEM'][flowindex])
                                        }
                                    }
                                }
                                ahuOn.push(ontime)
                                ahuTemps.push(ahuTempArray.reduce((p, c) => p + c, 0) / ahuTempArray.length)
                            }
                        }
                        me.ahuOnLayout.title="PAU Run Time (hr)";
                        me.ahuOnData = [{
                            x: ahuNames,
                            y: ahuOn,
                            type: 'scatter',
                            mode: 'markers',
                            marker: {
                                symbol: 'circle',
                                size: 10
                            }
                        }]
                        me.roomTempData = [{
                            x: ahuNames,
                            y: ahuTemps,
                            type: 'scatter',
                            mode: 'markers',
                            marker: {
                                symbol: 'circle',
                                size: 10
                            }
                        }]
                    })
                }
                getNotification({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range:currentRange,
                }).then(function(notifResult) {
                    let rangeFaults = notifResult.result
                    let cpFaultSeverity = { }
                    let cpFaultTopic = { }
                    for (let fault of rangeFaults){
                        if(!cpFaultSeverity[fault.severity]){
                            cpFaultSeverity[fault.severity]=1
                        } else {
                            cpFaultSeverity[fault.severity]=cpFaultSeverity[fault.severity]+1
                        }
                        if(!cpFaultTopic[fault.topic]){
                            cpFaultTopic[fault.topic]=1
                        } else {
                            cpFaultTopic[fault.topic]=cpFaultTopic[fault.topic]+1
                        }
                    }
                    let faultEquip = { }
                    for (let fault of rangeFaults){
                        if(!faultEquip[fault.equipment_type]){
                            faultEquip[fault.equipment_type]=1
                        } else {
                            faultEquip[fault.equipment_type]=faultEquip[fault.equipment_type]+1
                        }
                    }
                    me.faults=rangeFaults.sort((a, b) => (a.start_date < b.start_date) ? 1 : -1);
                    let faultPieData1={
                        type: 'pie',
                        hole: .7,
                        labels: [],
                        marker: {
                            colors:[],
                        },
                        values: []
                    }
                    for (let severity in cpFaultSeverity){
                        faultPieData1.labels.push(severity)
                        faultPieData1.marker.colors.push(me.severityColors[severity])
                        faultPieData1.values.push(cpFaultSeverity[severity])
                    }
                    me.faultPieData1=[faultPieData1];
                    let fddRepData=[]
                    let faultsByType={
                        'Chillers':rangeFaults.filter(x=>x.equipment_type.toLowerCase().startsWith('chiller')),
                        'Pumps':rangeFaults.filter(x=>x.equipment_type.toLowerCase().endsWith('water_pump')),
                        'VAVs':rangeFaults.filter(x=>x.equipment_type==="VAV")
                    }
                    if(me.ahus.length>0){
                        faultsByType['AHUs']=rangeFaults.filter(x=>x.equipment_type==="ECFAN"||x.equipment_type==="AHU")
                    } else if(me.paus.length>0){
                        faultsByType['PAUs']=rangeFaults.filter(x=>x.equipment_type==="PAU")
                    }
                    if(me.$store.state.pointsListStore.pointsList.facility_name==="CH"){
                        faultsByType['Cooling Towers']=rangeFaults.filter(x=>x.equipment_type==="COOLING_TOWER")
                    }
                    for (let faultType in faultsByType){
                        let part={
                            x:[],
                            y:[],
                            name: faultType,
                            type: 'bar',
                            orientation: 'h'
                        }
                        for (let topic in cpFaultTopic){
                            part.y.push(topic)
                            part.x.push(faultsByType[faultType].filter(x=>x.topic===topic).length)
                        }
                        fddRepData.push(part)
                    }
                    me.faultPieData2=fddRepData;
                })
                callAPI('data2/',
                    {
                        'filters': {
                            'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                            'sensor_names': ["Power"],
                            'date_range':currentRange,
                        },
                        "pipeline": [
                            {"type": "agg_h", "agg_op": "sum"},
                            {"type": "agg", "agg": "H", "agg_op": "sum"}
                        ]
                    }
                ).then(function(resc){
                    if(!resc||!resc.data.sum){
                        me.loading=false;
                        return
                    }
                    let currentPowerTotal=resc.data.sum.map(x=>x/me.$store.state.pointsListStore.pointsList.sampling_freq)
                    let hours=resc.data.timestamp.map(x=>moment(x).format("HH:mm"))
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'sensor_names': ["Power"],
                                'date_range':pastRange,
                            },
                            "pipeline": [
                                {"type": "agg_h", "agg_op": "sum"},
                                {"type": "agg", "agg": "H", "agg_op": "sum"}
                            ]
                        }
                    ).then(function(resp){
                        if(!resp||!resp.data.sum){
                            me.loading=false;
                            return
                        }
                        let pastTotalPower=resp.data.sum.map(x=>x/me.$store.state.pointsListStore.pointsList.sampling_freq)
                        me.energyData=[
                            {x:hours,y:currentPowerTotal,name:"Energy",fill: 'tozeroy',fillcolor:"rgba(31, 119, 180,0.5)",mode:"lines",line:{color:"rgba(31, 119, 180,0.5)"}},
                            {x:hours,y:pastTotalPower,
                                name:"Baseline (Previous "+pastdate.format('dddd')+" "+pastdate.format('YYYY-MM-DD')+")",
                                mode:"lines",
                                line:{color:"rgba(255, 127, 14,0.5)"}
                            },
                        ]
                        me.loading=false
                    })
                })

            }

        },
        beforeMount() {
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(maxDate){
                this.baseDate=moment(maxDate).subtract(1, "days")
                this.date=this.baseDate.format("YYYY-MM-DD")
            }
            this.getData();
        }



    }
</script>
